module.exports = __webpack_public_path__ + "assets/img/66@3x.e7a5c284.png";